import script from "./InquiryPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InquiryPage.vue?vue&type=script&setup=true&lang=js"

import "./InquiryPage.vue?vue&type=style&index=0&id=764f3a6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-764f3a6e"]])

export default __exports__